import { enqueueSnackbar, DownloadFile } from 'actions';
import { RETsExportRequest, RETEntireNetworkspExportRequest, GetRETFilesHistory } from '../requests/RetAuditRequests.js';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const GET_DUMPS_UPDATE = 'GET_DUMPS_UPDATE';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

const onLastDumpsUpdate = (dumpsUpdate) => ({
	type: GET_DUMPS_UPDATE,
	dumpsUpdate
});

export const LastDumpsUpdate = () => async (dispatch) => {
	await GetRETFilesHistory().then(response => {
		dispatch(onLastDumpsUpdate(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const RETspExport = (sites, userId) => async (dispatch) => {
	await RETsExportRequest(sites, userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const RETEntireNetworkspExport = (userId) => async (dispatch) => {
	await RETEntireNetworkspExportRequest(userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
